import { ERRORS } from "./messages";

// ---------------------------------------------------------------------------
// Funciones puras de cálculo y validación
// ---------------------------------------------------------------------------
export function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function parsePositive(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * Calcula la cantidad de material.
 * Devuelve null si faltan datos mínimos.
 */
export function calculateResult(product, options) {
    if (!product) return null;

    const { waste, computedArea, wallWidth, wallHeight } = options;
    const factor = waste === "with" ? 1.05 : 1.0;

    // Productos orientables (lambrines): se calculan por columnas × piezas por columna
    if (product.orientable) {
        const W = parsePositive(wallWidth);
        const H = parsePositive(wallHeight);
        if (W <= 0 || H <= 0) return null;

        // Instalación vertical: el ancho útil cubre el ancho del muro;
        // el largo de la pieza recorre la altura (sobrante = merma de corte).
        const runs = Math.ceil((W * factor) / product.usefulWidth);
        const perRun = Math.ceil(H / product.pieceLength);
        const quantity = runs * perRun;
        const acquiredArea = quantity * product.usefulWidth * product.pieceLength;

        return {
            quantity,
            product,
            baseArea: W * H,
            wasteApplied: waste,
            isOrientable: true,
            wallW: W,
            wallH: H,
            runs,
            perRun,
            areaLabel: `Material a adquirir (incluye corte de largo${waste === "with" ? " + 5%" : ""})`,
            areaValue: acquiredArea,
        };
    }

    // Pisos y productos por cobertura
    if (computedArea <= 0) return null;

    const totalWithWaste = computedArea * factor;
    const quantity = Math.ceil(totalWithWaste / product.coverage);

    return {
        quantity,
        product,
        baseArea: computedArea,
        wasteApplied: waste,
        isOrientable: false,
        areaLabel: `Área total requerida ${waste === "with" ? "(con 5% de merma)" : "(medida exacta)"}`,
        areaValue: totalWithWaste,
    };
}

/**
 * Valida los inputs del Paso 02 según el tipo de producto.
 * Devuelve un mensaje de error o null si todo está correcto.
 */
export function validateInputs(product, mode, area, length, width, wallWidth, wallHeight) {
    if (!product) return ERRORS.NO_PRODUCT;

    if (product.orientable) {
        if (parsePositive(wallWidth) <= 0) return ERRORS.NO_WALL_WIDTH;
        if (parsePositive(wallHeight) <= 0) return ERRORS.NO_WALL_HEIGHT;
        return null;
    }

    if (mode === "area") {
        if (parsePositive(area) <= 0) return ERRORS.NO_AREA;
        return null;
    }

    if (parsePositive(length) <= 0 || parsePositive(width) <= 0) {
        return ERRORS.NO_DIMENSIONS;
    }
    return null;
}

/**
 * Construye el mensaje prellenado de WhatsApp.
 */
export function buildWhatsAppMessage(result, leadName) {
    const base =
        `Hola Decototal, usé la calculadora de su web. Me interesa cotizar este producto: *${result.product.name}*. ` +
        `Área requerida: *${result.baseArea.toFixed(2)} m²*.`;

    const orientablePart = result.isOrientable
        ? ` Muro: *${result.wallW.toFixed(2)} × ${result.wallH.toFixed(2)} m*.`
        : "";

    const quantityPart = ` El resultado del cálculo indica que necesito adquirir: *${result.quantity} ${result.product.unit}*.`;
    const namePart = leadName ? ` Mi nombre es *${leadName}*.` : "";

    return base + orientablePart + quantityPart + namePart;
}